/*!
??TEST
=========================================================
* Argon Dashboard React - v1.2.3
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import { useState, useEffect } from "react";


// node.js library that concatenates classes (strings)
import classnames from "classnames";
// javascipt plugin for creating charts
import Chart from "chart.js";
// react plugin used to create charts
import { Line, Bar } from "react-chartjs-2";
import Plot from 'react-plotly.js';

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  NavItem,
  NavLink,
  Nav,
  Progress,
  Table,
  Container,
  Row,
  Col,
} from "reactstrap";

// core components
import {
  chartOptions,
  parseOptions,
  chartExample1,
  chartExample2,
} from "variables/charts.js";

import Header from "components/Headers/Header.js";
import Map from "views/Map.js"
import ProjectData from "assets/data/OffshoreWindProjectList-April2024.json"
// import timeseriesData from 'assets/dummy_data/timeseries.json'
import TimeseriesPlot from "components/Plots/timeseries";


const Index = (props) => {
  const [activeNav, setActiveNav] = useState(1);
  const [chartExample1Data, setChartExample1Data] = useState("data1");
  const [state, setState] = useState({
    lat: 39, lng: -73, zoom: 4.5,
    description: null,
    capacity: null,
    wind: null,
    output: null,
    capacity0: null,
    wind0: null,
    output0: null,
    capacity_f: null,
    wind_f: null,
    output_f: null,
    valid_time: null,
    max_cap: null
  });
  const [timeseriesData, setTimeseriesData] = useState(null);
  const [numSites, setNumSites] = useState(0);

  const TableKeys = Object.keys(ProjectData[Object.keys(ProjectData)[0]])

  if (window.Chart) {
    parseOptions(Chart, chartOptions());
  }
  const toggleNavs = (e, index) => {
    e.preventDefault();
    setActiveNav(index);
    setChartExample1Data("data" + index);
  };


  // const numSites = Object.keys(timeseriesData).length


  const fetchData = async (maxCap) => {
    console.log("api fetch")
    let newData = {}
    // fetch("http://169.226.68.142:30753/vowels-api")  
    // fetch("vowels-api")  
    fetch("https://xcitedb.asrc.albany.edu/vowels-api")
      .then(async response => {
        return await response.json()
      })
      .then(async data => {
        // console.log('data',data)
        let tempObj = {}
        Object.values(data.csv).map((d) => {
          // console.log('DATA',d)
          let site_name = d["Site Name"].trim()
          if (site_name.length > 0) {
            // console.log(site_name)

            let lease_num = d['Lease Number']
            if (lease_num.trim() != 'NA') site_name = maxCap[lease_num.match(/\d{4}/)[0]].proj

            if (site_name in newData) tempObj = newData[site_name]
            else tempObj = {}

            let date = d["Date (UTC)"], time = d["Time (UTC)"].padStart(4, '0')

            if (date.length > 0 && time.length > 0) {
              let datetime = new Date(Date.parse(`${date.slice(0, 4)}-${date.slice(4, 6)}-${date.slice(6, 8)}T${time.slice(0, 2)}:${time.slice(2, 4)}:00.000+00:00`))
              let fulltime = `${datetime.getFullYear()}-${(datetime.getMonth() + 1).toString().padStart(2, '0')}-${datetime.getDate().toString().padStart(2, '0')} ${datetime.getHours().toString().padStart(2, '0')}:${datetime.getMinutes().toString().padStart(2, '0')}`

              let actual = false
              if (d['Fcst or Actual'] == 'Actual') actual = true

              tempObj[fulltime] = {
                'lease': lease_num,
                'capacity': parseFloat(d['Net Cap Fac (%)']),
                'output': parseFloat(d['Net MW']),
                'wind': parseFloat(d['150m Wind Spd (m/s)']),
                'dir': parseFloat(d['150m Wind Dir']),
                'actual': actual,
                'heights': [10, 50, 80, 100, 150, 200, 300, 400, 500, 600, 800, 1000],
                'wind_profile': [parseFloat(d['10m Wind Spd (m/s)']),
                parseFloat(d['50m Wind Spd (m/s)']),
                parseFloat(d['80m Wind Spd (m/s)']),
                parseFloat(d['100m Wind Spd (m/s)']),
                parseFloat(d['150m Wind Spd (m/s)']),
                parseFloat(d['200m Wind Spd (m/s)']),
                parseFloat(d['300m Wind Spd (m/s)']),
                parseFloat(d['400m Wind Spd (m/s)']),
                parseFloat(d['500m Wind Spd (m/s)']),
                parseFloat(d['600m Wind Spd (m/s)']),
                parseFloat(d['800m Wind Spd (m/s)']),
                parseFloat(d['1000m Wind Spd (m/s)'])]
              }
              newData[site_name] = tempObj
            }
          }
        })
        // console.log('new data',newData)
        setTimeseriesData(newData)
      })

  }



  useEffect(() => {
    let maxCap = {}
    Object.values(ProjectData).map(v => {
      if (v["BOEM ID"])
        maxCap[v["BOEM ID"].match(/\d{4}/)[0]] = {
          'cap': v["MW Capacity"],
          'proj': v["Project "]
        }
    })
    setState({ ...state, max_cap: maxCap })

    fetchData(maxCap)
  }, [])


  useEffect(() => {
    // console.log('timeseries11',timeseriesData)
    if (timeseriesData) setNumSites(Object.keys(timeseriesData).length)
  }, [timeseriesData])


  useEffect(() => {
    console.log('state', state)
  }, [state])

  // useEffect(() =>{
  //     console.log('numSites',numSites)
  // }, [numSites])



  const colorbarItem = (color, text) => {
    return (
      <Row className="d-flex justify-content-start" style={{ alignItems: 'center' }}>
        <Col xl='2' sm='2' md='2' lg='2' xs='2' style={{}}>
          <div style={{ width: 20, height: 10, backgroundColor: color }} />
        </Col>
        <Col xl='8' sm='8' md='8' lg='8' xs='8'>
          <h6 className="text-uppercase text-muted ls-1 mb-0">
            {text}
          </h6>
        </Col>
      </Row>
    )

  }




  return (
    <>
      <Header num_sites={numSites} state={state} data={timeseriesData} />
      {/* Page content */}
      <Container className="mt--7" fluid>
        <Row>
          <Col className="mb-5 mb-xl-0" >
            <Card className="bg-gradient-default shadow">
              <CardHeader className="bg-transparent">
                <Row className="align-items-center">
                  <div className="col">
                    <h2 className="text-white mb-0">Offshore Wind Lease Areas</h2>
                    <h6 className="text-uppercase text-light ls-1 mb-1">
                      Valid Time: {state.valid_time}
                    </h6>
                  </div>
                </Row>
              </CardHeader>
              <CardBody>
                <div id='map-div' style={{ height: '540px' }}>
                  {timeseriesData ?
                    <Map state={state} setState={setState} data={timeseriesData} />
                    : null}
                </div>

                {state.description ?

                  <div style={{
                    display: 'flex', background: 'rgba(255,255,255,0.9)', position: 'absolute',
                    bottom: 30, right: 30, borderRadius: 5, padding: 10
                  }}>
                    <Col>
                      <Row>
                        <Col xl='9' sm='9' md='9' lg='9' xs='9'>
                          <h4 className="text-uppercase text-muted ls-1 mb-1">
                            Wind Profile
                          </h4>
                          <h2 className="mb-0">{state.description.area}</h2>
                        </Col>
                        <Col xl='1' sm='1' md='1' lg='1' xs='1'>
                          <div className='icon' onClick={() => setState({ ...state, description: null })} >
                            <i className="ni ni-fat-remove" style={{ size: 40, paddingRight: 10 }} />
                          </div>
                        </Col>
                      </Row>
                      {timeseriesData && state.description.area && timeseriesData[state.description.area] && state.valid_time && timeseriesData[state.description.area][state.valid_time] ?
                        <Row>
                          <Plot
                            data={[
                              {
                                x: timeseriesData[state.description.area][state.valid_time]['wind_profile'],
                                y: timeseriesData[state.description.area][state.valid_time]['heights'],
                                type: 'scatter',
                                mode: 'lines+markers',
                                marker: { color: 'black' },
                              },
                            ]}
                            layout={{
                              width: 240, height: 320, margin: { l: 50, r: 10, b: 45, t: 10, pad: 5 },
                              xaxis: { title: { text: 'Wind Speed (m/s)', }, },
                              yaxis: { title: { text: 'Height (m)', }, },
                            }}
                          />
                        </Row> : null}
                    </Col>
                  </div> : null
                }

                <div style={{ display: 'flex', background: 'rgba(255,255,255,0.9)', position: 'absolute', top: 120, right: 30, borderRadius: 5, padding: 10 }}>

                  <Col >
                    <Row className="d-flex justify-content-start">
                      <h6 className="text-uppercase text-muted ls-1 mb-1">
                        Net Capacity Factor
                      </h6></Row>
                    {colorbarItem('#b30000', '0-25%')}
                    {colorbarItem('#fb6340', '25-50%')}
                    {colorbarItem('#ffd600', '50-75%')}
                    {colorbarItem('#03cf77', '75-100%')}
                  </Col>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
        {timeseriesData ?
          <Row className="mt-5">
            <Col lg="6" xl="4" >
              <Card className="shadow">
                <CardHeader className="bg-transparent">
                  <Row className="align-items-center">
                    <div className="col">
                      <h2 className="mb-0">Wind Speed at 150 m (m/s)</h2>
                    </div>
                  </Row>
                </CardHeader>
                <CardBody>
                  <TimeseriesPlot wind data={timeseriesData} state={state} setState={setState} />
                </CardBody>
              </Card>
            </Col>
            <Col lg="6" xl="4"  >
              <Card className="shadow">
                <CardHeader className="bg-transparent">
                  <Row className="align-items-center">
                    <div className="col">
                      <h2 className="mb-0">Net Capacity Factor</h2>
                    </div>
                  </Row>
                </CardHeader>
                <CardBody>
                  <TimeseriesPlot capacity data={timeseriesData} state={state} setState={setState} />
                </CardBody>
              </Card>
            </Col>
            <Col lg="6" xl="4"  >
              <Card className="shadow">
                <CardHeader className="bg-transparent">
                  <Row className="align-items-center">
                    <div className="col">
                      <h2 className="mb-0">Output (MW)</h2>
                    </div>
                  </Row>
                </CardHeader>
                <CardBody>
                  <TimeseriesPlot output data={timeseriesData} state={state} setState={setState} />
                </CardBody>
              </Card>
            </Col>
          </Row>
          : null}
        <Row className="mt-5">
          <Col className="mb-5 mb-xl-0" xl="12">
            <Card className="shadow">
              <CardHeader className="border-0">
                <Row className="align-items-center">
                  <div className="col">
                    <h3 className="mb-0">Announced Offshore Wind Projects in the Eastern US (as of 1 April 2024)</h3>
                  </div>
                  {/* <div className="col text-right">
                    <Button
                      color="primary"
                      href="#pablo"
                      onClick={(e) => e.preventDefault()}
                      size="sm"
                    >
                      See all
                    </Button>
                  </div> */}
                </Row>
              </CardHeader>
              <Table height="20" responsive>
                <thead className="thead-light">
                  <tr>
                    {TableKeys.map(e => {
                      return (<th key={e} scope="col">{e}</th>)
                    })}
                  </tr>
                </thead>
                <tbody>
                  {Object.values(ProjectData).map(e => {
                    return (
                      <tr>
                        {Object.values(e).map((v, k) => {
                          if (k == 0) return (<th scope="row">{v}</th>)
                          else return (<td>{v}</td>)
                        })}
                      </tr>
                    )
                  })}

                </tbody>
              </Table>
            </Card>
          </Col>
          {/* <Col xl="4">
            <Card className="shadow">
              <CardHeader className="border-0">
                <Row className="align-items-center">
                  <div className="col">
                    <h3 className="mb-0">Social traffic</h3>
                  </div>
                  <div className="col text-right">
                    <Button
                      color="primary"
                      href="#pablo"
                      onClick={(e) => e.preventDefault()}
                      size="sm"
                    >
                      See all
                    </Button>
                  </div>
                </Row>
              </CardHeader>
              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col">Referral</th>
                    <th scope="col">Visitors</th>
                    <th scope="col" />
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th scope="row">Facebook</th>
                    <td>1,480</td>
                    <td>
                      <div className="d-flex align-items-center">
                        <span className="mr-2">60%</span>
                        <div>
                          <Progress
                            max="100"
                            value="60"
                            barClassName="bg-gradient-danger"
                          />
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Facebook</th>
                    <td>5,480</td>
                    <td>
                      <div className="d-flex align-items-center">
                        <span className="mr-2">70%</span>
                        <div>
                          <Progress
                            max="100"
                            value="70"
                            barClassName="bg-gradient-success"
                          />
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Google</th>
                    <td>4,807</td>
                    <td>
                      <div className="d-flex align-items-center">
                        <span className="mr-2">80%</span>
                        <div>
                          <Progress max="100" value="80" />
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Instagram</th>
                    <td>3,678</td>
                    <td>
                      <div className="d-flex align-items-center">
                        <span className="mr-2">75%</span>
                        <div>
                          <Progress
                            max="100"
                            value="75"
                            barClassName="bg-gradient-info"
                          />
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">twitter</th>
                    <td>2,645</td>
                    <td>
                      <div className="d-flex align-items-center">
                        <span className="mr-2">30%</span>
                        <div>cd .
                          <Progress
                            max="100"
                            value="30"
                            barClassName="bg-gradient-warning"
                          />
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </Table>
            </Card>
          </Col> */}
        </Row>
      </Container>
    </>
  );
};

export default Index;


